import {
  type MantineStyleProps,
  Title as MantineTitle,
  rem,
  type TitleProps,
} from "@mantine/core";

import { useResponsive } from "@/hooks/media";

type Props = {
  children: React.ReactNode;
} & MantineStyleProps &
  TitleProps;

export function Title(props: Props) {
  const { children, ...titleProps } = props;
  const defaultOption: TitleProps = {
    fz: "md",
  };
  const option = Object.assign({}, defaultOption, titleProps);
  return <MantineTitle {...option}>{children}</MantineTitle>;
}

export function H1(props: Props) {
  const { children, ...titleProps } = props;
  const { isMobile } = useResponsive();
  const defaultOption: TitleProps = {
    order: 1,
    fz: isMobile ? rem(24) : undefined,
  };
  const option = Object.assign({}, defaultOption, titleProps);
  return <MantineTitle {...option}>{children}</MantineTitle>;
}
export function H2(props: Props) {
  const { children, ...titleProps } = props;
  const { isMobile } = useResponsive();
  const defaultOption: TitleProps = {
    order: 2,
    fz: isMobile ? rem(20) : undefined,
  };
  const option = Object.assign({}, defaultOption, titleProps);
  return <MantineTitle {...option}>{children}</MantineTitle>;
}
export function H3(props: Props) {
  const { children, ...titleProps } = props;
  const { isMobile } = useResponsive();
  const defaultOption: TitleProps = {
    order: 3,
    fz: isMobile ? rem(18) : undefined,
  };
  const option = Object.assign({}, defaultOption, titleProps);
  return <MantineTitle {...option}>{children}</MantineTitle>;
}
export function H4(props: Props) {
  const { children, ...titleProps } = props;
  const defaultOption: TitleProps = {
    order: 4,
  };
  const option = Object.assign({}, defaultOption, titleProps);
  return <MantineTitle {...option}>{children}</MantineTitle>;
}
export function H5(props: Props) {
  const { children, ...titleProps } = props;
  const defaultOption: TitleProps = {
    order: 5,
  };
  const option = Object.assign({}, defaultOption, titleProps);
  return <MantineTitle {...option}>{children}</MantineTitle>;
}

// Title.H1 = H1;
// Title.H2 = H2;
// Title.H3 = H3;
// Title.H4 = H4;
// Title.H5 = H5;
